export const state = () => ({
  showFreeTrialStartedStep: false,
})

export const mutations = {
  SET_SHOW_FREE_TRIAL_STARTED_STEP(state, value) {
    state.showFreeTrialStartedStep = value
  },
}

export const actions = {
  setShowFreeTrialStep({ commit }, value) {
    commit('SET_SHOW_FREE_TRIAL_STARTED_STEP', value)
  },
}

export const getters = {
  getShowFreeTrialStep(state) {
    return state.showFreeTrialStartedStep
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
